import { useState } from "react";
import { Row, Col, Modal, Button, Image } from "react-bootstrap";
import { ArrowRightCircle } from 'react-bootstrap-icons';

export default function Info({ agenda, item }) {

  // console.log(agenda);
  // console.log(item);

  const [showModal, setShowModal] = useState(false);
  const [showRoleDescription, setShowRoleDescription] = useState(false); // State to manage description visibility
  const [showEventDescription, setShowEventDescription] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(
    agenda.findIndex(agendaItem => agendaItem.agendaItemId === item.agendaItemId)
  );

  const currentItem = agenda[currentIndex];

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => {
    // Update the currentIndex based on the item passed to the Timer component
    const newIndex = agenda.findIndex(agendaItem => agendaItem.agendaItemId === item.agendaItemId);
    setCurrentIndex(newIndex);
    setShowModal(true);
  };
  const toggleRoleDescription = () => setShowRoleDescription(!showRoleDescription); // Toggle description visibility
  const toggleEventDescription = () => setShowEventDescription(!showEventDescription);

  // Handle navigation to the next item
  const handleNextItem = () => {
    if (currentIndex < agenda.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  // Handle navigation to the previous item
  const handlePreviousItem = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <>
      <Button variant="link" onClick={handleShowModal} style={{ padding: 0, border: 'none', background: 'none', textDecoration: 'none' }} className="me-4">
        <i className="bi bi-info-circle" style={{ fontSize: '24px', color: '#fff' }}></i>
      </Button>
      <Modal
        centered
        show={showModal}
        onHide={handleCloseModal}
        className='text-center'
        data-bs-theme={'dark'}
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className='text-inline'> {currentItem?.meetingTheme}  </h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: 'linear-gradient( #003f61 -100%, #78222f 151.58%)', position: 'relative' }} className="timer">
          <Row>
            <Col>
              <h1 className='golden-text mb-2' onClick={toggleRoleDescription} style={{ cursor: 'pointer' }}>{currentItem.meetingRole.name} <ArrowRightCircle size={30} /> </h1>
            </Col>
          </Row>
          <Row>
            <Col xs={1} lg={2} xl={3}></Col>
            <Col>
              <div dangerouslySetInnerHTML={{ __html: currentItem.meetingRole.description }} style={{ display: showRoleDescription ? 'block' : 'none' }}></div>
            </Col>
            <Col xs={1} lg={2} xl={3}></Col>
          </Row>
          <Row>
            <Col>
              <h4 className='text-inline'>{currentItem?.startTime} </h4>
              <h1 onClick={toggleEventDescription} className='text-inline' style={{ cursor: 'pointer' }}>{currentItem.agendaEvent.name} <ArrowRightCircle size={30} /> </h1>
            </Col>
          </Row>
          <Row>
            <Col xs={1} lg={2} xl={3}></Col>
            <Col>
              <div dangerouslySetInnerHTML={{ __html: currentItem.agendaEvent.description }} style={{ display: showEventDescription ? 'block' : 'none' }}></div>
            </Col>
            <Col xs={1} lg={2} xl={3}></Col>
          </Row>
          {(currentItem.assignedUser && currentItem.assignedUser.avatar) ?
            <Row className='avatar'>
              <Col className='hexagon'>
                <Image src={'data:image/png;base64, ' + currentItem.assignedUser.avatar} />
              </Col>
            </Row>
            : ''}
          <Row>
            <Col>
              <h1 style={{ fontSize: '72px' }}>
                {currentItem.assignedUser?.firstName.toUpperCase() || 'TBA'}
              </h1>
              <h5 style={{ cursor: 'pointer' }}>
                {currentItem.assignedUser?.lastName.toUpperCase() || 'TBA'}
              </h5>
            </Col>
          </Row>
        </Modal.Body >
        <Modal.Footer className="d-flex justify-content-between">
          <div style={{ justifyContent: 'flex-start' }} className='float-start'>
            <Button
              onClick={handlePreviousItem}
              disabled={currentIndex === 0}
              className="me-2"
            >
              Previous
            </Button>
            <Button
              onClick={handleNextItem}
              disabled={currentIndex === agenda.length - 1}
            >
              Next
            </Button>
          </div>
          <div style={{ justifyContent: 'flex-end' }} className='float-end'>
            <Button variant='success' onClick={handleCloseModal}>
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal >
    </>
  );
}